import ApiCampains from './ApiCampaignsClient';

class ContactsAndConversationAPI extends ApiCampains {
  constructor() {
    super('contactsAndConversationReport', { accountScoped: true });
  }

  getContactsAndConversations(params) {
    return axios.get(this.baseCampaingUrl() + "/accounts/" + this.accountIdFromRoute + "/report-manager/reports", {
     /* headers: {
        'access-token': "EeZCyS8RYaGI9wbEuCJRSg",
        'token-type': "Bearer",
        'client': "8qifVtQWgOtbVWuiMn-Vsg",
        'expiry': 1728919988,
        'uid': "jjvasquezcabos@gmail.com",
      }*/
    });
  }

  download(params) {

    

   const data ={
      account_id: this.accountIdFromRoute,
      report_type:params.report_type ,
      date_range:params.report_type !="0"? params.from +" - "+params.to : "",
      status: 0,
      url: null,
      jvp_report_request_config: {},
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone // Adding the timezone attribute
    }
   
    return axios.post(this.baseCampaingUrl() + "/accounts/" + this.accountIdFromRoute + "/report-manager/reports", data,{
    /*  headers: {
      'Content-Type': 'application/json',
        'access-token': "EeZCyS8RYaGI9wbEuCJRSg",
        'token-type': "Bearer",
        'client': "8qifVtQWgOtbVWuiMn-Vsg",
        'expiry': 1728919988,
        'uid': "jjvasquezcabos@gmail.com",
      }*/
    });
  }
}

export default new ContactsAndConversationAPI();
